// extracted by mini-css-extract-plugin
export var box = "_41-0";
export var check = "_41-1";
export var checkboxButton = "_41-6";
export var checkboxGroup = "_41-5";
export var disabled = "_41-7";
export var ghost = "_41-9";
export var input = "_41-2";
export var label = "_41-4";
export var normal = "_41-8";
export var uncheck = "_41-3";